<!-- Contenedor principal -->
<div class="card-header mb-4">
  <div class="title-section">
    <h2 class="header-title">
      Generar Reporte {{ reportOrigin }} <span class="text-muted">{{ data.reportId }} | {{ data.reportName }} | {{ numeroOperacion }} {{ numeroSolicitud }}</span>
    </h2>
  </div>
  <div class="search-section">
    <div class="button-section">
      <button mat-flat-button (click)="goBack()" class="btn-new">
        <mat-icon>arrow_back</mat-icon>
        Volver
      </button>
    </div>
  </div>
</div>

<!-- Formulario de Filtros -->
@if(errorReport) {

<div class="center-column">
  <h4 style="font-style: italic">Error al generar el reporte.</h4>
  <button mat-flat-button (click)="generateReport(fields)" class="btn-success">
    <mat-icon>plagiarism</mat-icon>
    Intentar nuevamente
  </button>
</div>
} @else {

<div *ngIf="reportType == 1" class="center-column">
  <h4 style="font-style: italic">No hay filtros para este reporte.</h4>
</div>
<div *ngIf="reportType != 1">
  <h3 class="title-section">Filtros del Reporte</h3>
  <div class="form-row">
    <ng-container *ngFor="let field of fields">
      <div *ngIf="!field.isNull">
      <div *ngIf="field.options && field.options.length > 0" class="form-field">
        <select class="form-control" [(ngModel)]="field.value">
          <option *ngFor="let option of field.options" [value]="option.id">
            {{ option.description }}
          </option>
        </select>
        <label>{{ field.label }}</label>
      </div>
      <div *ngIf="!(field.options && field.options.length > 0)" class="form-field">
        <input [type]="getType(field.type)" class="form-control" [(ngModel)]="field.value" />
        <label>{{ field.label }}</label>
      </div>
      </div>
    </ng-container>
  </div>
  <div class="button-section">
    <button mat-flat-button (click)="generateReport(fields)" class="btn-success">
      <mat-icon>plagiarism</mat-icon>
      Generar Reporte
    </button>
    <button mat-flat-button (click)="downloadCSV(file, this.reportingDataFilter.reportName)" class="btn-new" *ngIf="file != null">
      <mat-icon>download</mat-icon>
      Descargar .CSV
    </button>
    <button mat-flat-button (click)="exportarExcel()" class="btn-new" *ngIf="tableData && tableData.length > 0">
      <mat-icon>table_chart</mat-icon>
      Descargar Excel
    </button>
  </div>
</div>

<hr class="col-11" />

@if ( file != null) {
<p-table
  [value]="tableData"
  [rowsPerPageOptions]="[10, 15, 50]"
  [paginator]="true"
  [rows]="10"
  [showCurrentPageReport]="true"
  responsiveLayout="scroll"
  currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
>
  <ng-template pTemplate="header">
    <tr>
      <th class="th-prime" *ngFor="let col of tableColumns">{{ col }}</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-row>
    <tr>
      <td class="td-prime" *ngFor="let col of tableColumns">{{ row[col] }}</td>
    </tr>
  </ng-template>
</p-table>
}@else { } }
